import { MicrosoftTemplate, CustomTemplate } from 'types/template';
export const isMicrosoftTemplate = (
  template: MicrosoftTemplate | CustomTemplate
): template is MicrosoftTemplate => 'value' in template;
